// extracted by mini-css-extract-plugin
module.exports = {"selectedRows":"Table_selectedRows__2IsHZ"};